export default __webpack_public_path__ + "static/media/creative.aa0d201b.png";